export enum EFeature {
  createReservation = 'CREATE_RESERVATION',
  createPropertyOwner = 'CREATE_PROPERTY_OWNER',
  createVrboAccount = 'CREATE_VRBO_ACCOUNT',
  userGroups = 'USE_GROUPS',
}
